import { ICurrentUser, INeighborhoodTableRecord } from '@api'
import { IPermissionsOnNeighborhood } from './types'
import { isAdmin, isLocationAdmin, isDepartmentAdmin, isSpaceCaptain } from '@utils'

function canLocationAdminManageNeighborhood(
  user: ICurrentUser,
  neighborhoods: INeighborhoodTableRecord[] | null
) {
  if (!neighborhoods) return false

  return neighborhoods.every(({ floor: { id } }) =>
    user.employee.locationAdmins.find(({ floorPlan }) => id === floorPlan.id)
  )
}

function canDepartmentDeleteNeighborhood(
  user: ICurrentUser,
  neighborhoods: INeighborhoodTableRecord[] | null
) {
  if (!neighborhoods) return false

  return neighborhoods.every(({ createdBy }) => user.employee.id === createdBy?.employee.id)
}

export function onNeighborhood(
  user: ICurrentUser,
  neighborhoods: INeighborhoodTableRecord[] | null
): IPermissionsOnNeighborhood {
  const permissions = {
    canUpdate: true,
    canDelete: true,
    canAddEmployees: true,
    canRemoveEmployees: true,
    canAddSpaces: true,
    canRemoveSpaces: true,
    canOpenReport: true,
  }

  if (user.isSuperUser || isAdmin(user.employee.role)) return permissions

  if (isLocationAdmin(user.employee.role)) {
    const canManage = canLocationAdminManageNeighborhood(user, neighborhoods)

    return {
      ...permissions,
      canDelete: canManage,
      canUpdate: canManage,
      canAddEmployees: canManage,
      canRemoveEmployees: canManage,
      canAddSpaces: canManage,
      canRemoveSpaces: canManage,
      canOpenReport: true,
    }
  }

  if (isDepartmentAdmin(user.employee.role) || isSpaceCaptain(user.employee.role)) {
    const canDelete = canDepartmentDeleteNeighborhood(user, neighborhoods)

    return {
      ...permissions,
      canDelete: canDelete,
      canUpdate: true,
      canAddEmployees: true,
      canRemoveEmployees: true,
      canAddSpaces: true,
      canRemoveSpaces: true,
      canOpenReport: false,
    }
  }

  return {
    canUpdate: false,
    canDelete: false,
    canAddEmployees: false,
    canRemoveEmployees: false,
    canAddSpaces: false,
    canRemoveSpaces: false,
    canOpenReport: false,
  }
}
